/**
 * This theme is mainly controlled by adjusting the PrimaryMain and
 * secondaryMain color variables. Material UI is smart enough to complement these
 * choices. This file only adjust lightMode.
 *
 * Colors are modified in the lightThemeMode under the palette property. Notice that many of the colors can be programmatically generated via functions from Material UI.
 *
 * Some useful links for working with themes can be found at:
 * https://themes.material-ui.com/
 * https://material-ui.com/customization/default-theme/ //Will show all the properties you can edit
 * https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=c24f00&secondary.color=214563 //great for color selecting
 */

import { ThemeOptions } from '@material-ui/core';
import { defaultTheme, defaultDarkTheme, AlmeTheme } from '../../../models/AlmeTheme';


const primaryMain = '#000000';
const primaryContrast = defaultTheme.palette.getContrastText(primaryMain);


const palette = {
    primary: {
        light: '#007AFF',
        main: primaryMain,
        dark: '#0D3E86',
    },
    //effects the button for sending user message
    secondary: {
        light: '#00CE7C',
        main: primaryContrast,
        dark: '#0D7F46',
    },
    //Effects the main body of the IVA
    background: {
        paper: '#FFFFFF', //effects individual messages
        default: '#FFFFFF', //effects the main body of the IVA
    },
};

const lightModeTheme = { palette } as ThemeOptions;


export const appThemeMain = {
    lightTheme: lightModeTheme,
    darkTheme: defaultDarkTheme,
} as AlmeTheme;